// Net-worth trend & movers (`/accounts/trend`, design `#s02`). M3 has not
// supplied a coherent canonical aggregate contract yet, so M1 retains the
// route heading/date guard and renders an honest page-local unavailable state.
// It never composes a trend from account rows or a legacy/current response.
import { Link, useLocation } from 'react-router-dom';
import { useShellContext } from '@/app/shell/AppShell';
import { RouteRecoveryScreen } from '@/app/states/RouteStates';
import { scopeHref } from '@/app/shell/scope';
import { DateScopeGuard } from '@/app/shell/DateScopeGuard';

function TrendPageContent() {
  const isOffline = typeof navigator !== 'undefined' && navigator.onLine === false;
  if (isOffline) return <RouteRecoveryScreen kind="offline" frame="inline" />;

  return <p role="status" className="rounded-md border border-degraded-border bg-degraded-surface p-4 text-sm text-degraded-foreground">Net worth history is not available yet.</p>;
}

export function TrendPage() {
  const { dateScopeAvailability, band } = useShellContext();
  const location = useLocation();
  return (
    <section aria-labelledby="trend-heading" className="mx-auto max-w-5xl px-4 py-6">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        {band === 'mobile' && (
          <Link to={scopeHref(`/accounts${location.hash}`, location.search)} className="flex min-h-11 items-center text-sm text-link">
            ‹ Accounts
          </Link>
        )}
        <h1 id="trend-heading" tabIndex={-1} className="text-title font-semibold">
          Net worth trend
        </h1>
      </div>
      <DateScopeGuard availability={dateScopeAvailability}><TrendPageContent /></DateScopeGuard>
    </section>
  );
}

export default TrendPage;
